import SellerWebhooksAPI from '@/api/seller-webhooks.api'

const state = {
  ringbaWebhooks: [],
  sellerWebhook: null,
  loadingWebhooks: false,
  loadingSellerWebhook: false
}

/**
 * @type {import('vuex').GetterTree<typeof state>}
 */
const getters = {
  hasWebhookConfigured(state) {
    return state.sellerWebhook != null
  },

  availableWebhooks(state) {
    return state.ringbaWebhooks
  },

  sellerWebhook(state) {
    return state.sellerWebhook
  },

  isLoadingWebhooks(state) {
    return state.loadingWebhooks
  },

  isLoadingSellerWebhook(state) {
    return state.loadingSellerWebhook
  }
}

/**
 * @type {import('vuex').ActionTree<typeof state>}
 */
const actions = {
  /**
   * Fetch all webhooks from the seller's Ringba account
   */
  async fetchRingbaWebhooks({ commit }, { accountId }) {
    commit('SET_LOADING_WEBHOOKS', true)
    try {
      const response = await SellerWebhooksAPI.listRingbaWebhooks(accountId)
      commit('SET_RINGBA_WEBHOOKS', response.data)
      return response.data
    } finally {
      commit('SET_LOADING_WEBHOOKS', false)
    }
  },

  /**
   * Select and save an existing webhook from Ringba
   */
  async selectWebhook({ commit }, { accountId, ringbaWebhookId }) {
    const response = await SellerWebhooksAPI.selectWebhook(accountId, ringbaWebhookId)
    commit('SET_SELLER_WEBHOOK', response.data)
    return response.data
  },

  /**
   * Fetch the saved webhook configuration for the seller
   */
  async fetchSellerWebhook({ commit }, { accountId }) {
    commit('SET_LOADING_SELLER_WEBHOOK', true)
    try {
      const response = await SellerWebhooksAPI.getSellerWebhook(accountId)
      commit('SET_SELLER_WEBHOOK', response.data)
      return response.data
    } catch (error) {
      // If 404, seller has no webhook configured - this is expected
      if (error.response?.status === 404) {
        commit('SET_SELLER_WEBHOOK', null)
        return null
      }
      throw error
    } finally {
      commit('SET_LOADING_SELLER_WEBHOOK', false)
    }
  },

  /**
   * Clear the webhook state (useful when switching accounts)
   */
  clearWebhookState({ commit }) {
    commit('SET_RINGBA_WEBHOOKS', [])
    commit('SET_SELLER_WEBHOOK', null)
  }
}

/**
 * @type {import('vuex').MutationTree<typeof state>}
 */
const mutations = {
  SET_RINGBA_WEBHOOKS(state, webhooks) {
    state.ringbaWebhooks = webhooks
  },

  SET_SELLER_WEBHOOK(state, webhook) {
    state.sellerWebhook = webhook
  },

  SET_LOADING_WEBHOOKS(state, loading) {
    state.loadingWebhooks = loading
  },

  SET_LOADING_SELLER_WEBHOOK(state, loading) {
    state.loadingSellerWebhook = loading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
